import { makeAutoObservable } from "mobx";

class UI {
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (flag: boolean) => {
    this.isLoading = flag;
  };
}

export default new UI();
